import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FirmwareUpdateStore } from '@store';

import {
  BundleUpdateProgressEnum,
  BundleUpdateStatusEnum,
  XotaBundleUpdateStep,
} from '@vi-iot/client/index';
import { isEqual } from 'lodash';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-firmware-update-version-list',
  templateUrl: './firmware-update-version-list.component.html',
  styleUrls: ['./firmware-update-version-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateVersionListComponent implements OnInit, OnDestroy {
  @Input() gatewaySerial: string;
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  protected readonly BundleUpdateStatus = BundleUpdateStatusEnum;
  protected readonly BundleUpdateProgress = BundleUpdateProgressEnum;
  protected readonly XotaBundleUpdateStep = XotaBundleUpdateStep;

  private maxProgress = 100;

  salesForceCaseNumber: string;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(public firmwareUpdateStore: FirmwareUpdateStore) {}

  ngOnInit(): void {
    this.firmwareUpdateStore.versionListParams$
      .pipe(distinctUntilChanged(isEqual), takeUntil(this.ngUnsubscribe))
      .subscribe((versionListParams) => {
        if (versionListParams.overallProgress < this.maxProgress) {
          this.saveProgressToLocal();
        }
      });

    this.firmwareUpdateStore.salesForceCaseNumber$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((caseNumber) => {
        this.salesForceCaseNumber = caseNumber;
      });
  }

  onCancel(): void {
    this.cancel.emit();
    this.firmwareUpdateStore.clearLocalStorageKey(this.gatewaySerial);
  }

  updateFirmware(): void {
    this.salesForceCaseNumber
      ? this.firmwareUpdateStore.checkOneTimeServiceApprovalForUpdateProcess(
          this.salesForceCaseNumber
        )
      : this.firmwareUpdateStore.triggerUpdateFirmwareProcess();
  }

  private saveProgressToLocal(): void {
    this.firmwareUpdateStore.saveLocalStorageFirmwareUpdateState(this.gatewaySerial);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.firmwareUpdateStore.clearLocalStorageKey(this.gatewaySerial);
  }
}
